import { render } from "./Contatti.vue?vue&type=template&id=0b80d7d2"
import script from "./Contatti.vue?vue&type=script&lang=js"
export * from "./Contatti.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__